export const engagementContentBlocksNames = "/engagement/content_blocks/names";
